module.exports = __webpack_public_path__ + "static/img/rank_106.3416822.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_106.png
// module id = JnpJ
// module chunks = 1